import { type PropsWithChildren, useId, useState } from 'react'

import {
  type RadioGroupContextValue,
  type RadioGroupInputValue,
  RadioGroupProvider,
} from './RadioGroup.context'

export type RadioGroupProps = RadioGroupContextValue & PropsWithChildren

const RadioGroup = ({ children, name, value, onChange, ...props }: RadioGroupProps) => {
  const _name = useId()
  const [_value, _setValue] = useState(value)
  // value prop 이 주어지면 controlled — 내부 상태를 거치지 않아 falsy 값(해제 '')도 그대로 반영된다.
  const isControlled = value !== undefined

  const handleChange = (v: RadioGroupInputValue, e?: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(v, e)

    if (!isControlled) {
      _setValue(v)
    }
  }

  return (
    <RadioGroupProvider
      name={name ?? _name}
      value={isControlled ? value : _value}
      onChange={handleChange}
      {...props}
    >
      {children}
    </RadioGroupProvider>
  )
}

export default RadioGroup
